import axios from 'axios'
import qs from 'qs'
import { getRequestSign } from 'lib/tools/platformSign'
import { GetQueryString } from 'lib/tools/utils'

const $http = axios.create()

let _version, _platform
if (!EASY_ENV_IS_NODE) {
  _version = GetQueryString('_version', window.location.hash)
  _platform = GetQueryString('_platform', window.location.hash)
}

const baseParams = {
  _version: _version || '6.5.0',
  _platform: _platform || 'ios'
}

// 不加盐get请求
const $httpGet = (api, params) => {
  let _params = Object.assign({}, baseParams, params)
  let platFormSign = getRequestSign(_params)

  return $http.get(api, {
    params: Object.assign(platFormSign.params, {
      sign: platFormSign.sign
    })
  })
}

// 不用新的axios实例，直接用axio本身，确保可以被全局的拦截器拦截
const axiosGet = (api, params) => {
  let _params = Object.assign({}, baseParams, params)
  let platFormSign = getRequestSign(_params)

  const r = {
    params: Object.assign(platFormSign.params, {
      sign: platFormSign.sign
    })
  }
  return axios.get(api, r)
}

// 加盐get请求
const yiapiRequestGet = (api, params) => {
  let _params = Object.assign({}, baseParams, params)
  let platFormSign = getRequestSign(_params)

  return axios.get(api, {
    params: Object.assign(platFormSign.params, {
      sign: platFormSign.sign
    })
  })
}
// 加盐post请求
const yiapiRequestPost = (api, params) => {
  let _params = Object.assign({}, baseParams, params)
  let platFormSign = getRequestSign(_params)
  return axios.post(
    api,
    qs.stringify(
      Object.assign(platFormSign.params, {
        sign: platFormSign.sign
      })
    ),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

export {
  baseParams,
  $http,
  $httpGet,
  axiosGet,
  yiapiRequestGet,
  yiapiRequestPost
}
